class BackToTopButton {
    constructor() {
        this.button = document.querySelector(".back-to-top");
        this.init();
    }

    init() {
        if (!this.button) {
            this.createButton();
        }

        if (this.button) {
            this.button.classList.add("hidden");
        }

        if (this.button) {
            this.button.addEventListener("click", this.scrollToTop.bind(this));
            window.addEventListener(
                "scroll",
                this.toggleButtonVisibility.bind(this)
            );
        }
    }

    createButton() {
        this.button = document.createElement("button");
        this.button.classList.add("back-to-top");
        this.button.innerHTML = '<i class="bb-icon-l bb-icon-arrow-up"></i>';
        this.button.setAttribute("aria-label", "Back to top");
        document.body.appendChild(this.button);
    }

    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }

    toggleButtonVisibility() {
        if (window.scrollY > 300) {
            this.button.classList.add("visible");
        } else {
            this.button.classList.remove("visible");
        }
    }
}

export default BackToTopButton;
